/** Цветовая система для графиков дашборда — см. skill dataviz, references/palette.md. Светлая тема. */

export const vizColor = {
  surface: '#fcfcfb',
  page: '#f9f9f7',
  textPrimary: '#0b0b0b',
  textSecondary: '#52514e',
  textMuted: '#898781',
  grid: '#e1e0d9',
  axis: '#c3c2b7',
  successText: '#006300',
  border: 'rgba(11,11,11,0.10)',
} as const;

/** Фиксированный порядок категориальных цветов — слоты не переставлять (CVD-безопасность). */
export const categorical = [
  '#2a78d6', // 1 blue
  '#eb6834', // 2 orange
  '#1baf7a', // 3 aqua
  '#eda100', // 4 yellow
  '#e87ba4', // 5 magenta
  '#008300', // 6 green
  '#4a3aa7', // 7 violet
  '#e34948', // 8 red
] as const;

export const status = {
  Рост: { color: '#0ca30c', icon: '▲' },
  Держится: { color: '#898781', icon: '●' },
  Падение: { color: '#d03b3b', icon: '▼' },
} as const;

export type StatusKind = keyof typeof status;

export function compactNumber(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—';
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  if (abs >= 1_000_000) {
    const v = abs / 1_000_000;
    return `${sign}${v.toFixed(v >= 10 ? 0 : 1).replace('.', ',')} млн`;
  }
  if (abs >= 1_000) {
    const v = abs / 1_000;
    return `${sign}${v.toFixed(v >= 10 ? 0 : 1).replace('.', ',')} тыс`;
  }
  return `${sign}${Math.round(abs)}`;
}

export function formatFullNumber(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—';
  return Math.round(n)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/** value — доля (0.053 = 5,3%) */
export function formatPercentFraction(value: number | null | undefined, digits = 1): string {
  if (value == null || Number.isNaN(value)) return '—';
  return `${(value * 100).toFixed(digits).replace('.', ',')}%`;
}

/** value — уже проценты (6.0 = 6,0%) */
export function formatPercentValue(value: number | null | undefined, digits = 1): string {
  if (value == null || Number.isNaN(value)) return '—';
  return `${value.toFixed(digits).replace('.', ',')}%`;
}

export function formatDelta(value: number | null | undefined, digits = 1): string {
  if (value == null || Number.isNaN(value)) return '—';
  const pct = value * 100;
  const sign = pct > 0 ? '+' : '';
  return `${sign}${pct.toFixed(digits).replace('.', ',')}%`;
}

/** Округление верхней границы оси до "красивого" числа (1/2/5 × 10^n). */
export function niceMax(value: number): number {
  if (value <= 0) return 1;
  const exp = Math.floor(Math.log10(value));
  const base = Math.pow(10, exp);
  const frac = value / base;
  let niceFrac: number;
  if (frac <= 1) niceFrac = 1;
  else if (frac <= 2) niceFrac = 2;
  else if (frac <= 5) niceFrac = 5;
  else niceFrac = 10;
  return niceFrac * base;
}

export function buildTicks(max: number, count = 4): number[] {
  const top = niceMax(max);
  const step = top / count;
  return Array.from({ length: count + 1 }, (_, i) => i * step);
}
